module.exports = __webpack_public_path__ + "img/violet_067.9cc72f0b.png";